/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Icd10Option } from './icd10Option';
import { DiagnosisClassificationEnum } from './diagnosisClassificationEnum';
import { DiagnosisCertaintyEnum } from './diagnosisCertaintyEnum';
import { DiagnosisTherapist } from './diagnosisTherapist';
import { PatientAppointment } from './patientAppointment';


/**
 * One diagnosis in the patient file\'s diagnosis drawer.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientDiagnosis { 
    readonly id: number;
    readonly icd10Code: Icd10Option;
    readonly classification: DiagnosisClassificationEnum;
    readonly certainty: DiagnosisCertaintyEnum;
    readonly certaintySuffix: string;
    readonly appointment: PatientAppointment | null;
    readonly therapist: DiagnosisTherapist | null;
    readonly documentedAt: string;
    readonly updatedAt: string | null;
}
export namespace PatientDiagnosis {
}

export const PatientDiagnosis_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_icd10Code_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_classification_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_certainty_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_certaintySuffix_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_appointment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_documentedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosis_updatedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];


